export default "__VITE_ASSET__DJoHBXfm__"